import TeamSettings from './TeamSettings';

export default TeamSettings;
